import React from 'react'
import { Trans } from 'react-i18next'
import i18next from 'i18next'
import { ReactComponent as UsersIcon } from 'images/icons/icn_users.svg'
import { ReactComponent as BrokenRacket } from 'images/icons/icn_broken_racket_lg.svg'
import { ReactComponent as FourOFour } from 'images/icons/icn_large_404.svg'
import { ReactComponent as Robot } from 'images/icons/icn_large_robot.svg'
import { ReactComponent as LargeErrorSign } from 'images/icons/icn_large_error.svg'
import { ReactComponent as RefreshIcon } from 'images/icons/icn_refresh.svg'
import { ReactComponent as HomeIcon } from 'images/icons/icn_home.svg'
import { ReactComponent as BackIcon } from 'images/icons/icn_arrow_left.svg'
import { ReactComponent as ComingSoonIcon } from 'images/icons/icn_coming_soon.svg'
import { getSignInUrl, getSignOutUrl } from 'utils'

export enum MessageTypes {
  PLAYER_NOT_FOUND = 'PLAYER_NOT_FOUND',
  INVITE_REQUIRED = 'INVITE_REQUIRED',
  OWN_PROFILE_ERROR = 'OWN_PROFILE_ERROR',
  PAGE_RESTRICTED = 'PAGE_RESTRICTED',
  SIGNOUT_REQUIRED = 'SIGNOUT_REQUIRED',
  PAGE_NOT_FOUND = 'PAGE_NOT_FOUND',
  NETWORK = 'NETWORK',
  ALREADY_REGISTERED = 'ALREADY_REGISTERED',
  FAST_TRACK_ERROR = 'FAST_TRACK_ERROR',
  ACTIVATION_ERROR = 'ACTIVATION_ERROR',
  ACTIVATION_LOGIN_PROMPT = 'ACTIVATION_LOGIN_PROMPT',
  RECAPTCHA_VALIDATION_ERROR = 'RECAPTCHA_VALIDATION_ERROR',
  UNABLE_SUBMIT_PSQ = 'UNABLE_SUBMIT_PSQ',
  PSQ_SUBMIT_ERROR = 'PSQ_SUBMIT_ERROR',
  REGISTRATION_COMING_SOON = 'REGISTRATION_COMING_SOON',
  APP_ERROR = 'APP_ERROR',
  DEFAULT = 'DEFAULT',
}

export const getMessageScreens = () =>
  ({
    [MessageTypes.PLAYER_NOT_FOUND]: {
      icon: <UsersIcon />,
      header: i18next.t('playerNotFound', { ns: 'strMessageScreen' }),
      infoText: i18next.t('playerNotFoundInfo', { ns: 'strMessageScreen' }),
    },
    [MessageTypes.INVITE_REQUIRED]: {
      icon: <UsersIcon />,
      header: i18next.t('inviteRequired', { ns: 'strMessageScreen' }),
      infoText: i18next.t('inviteRequiredInfo', { ns: 'strMessageScreen' }),
      backLinkText: i18next.t('inviteRequiredLink', { ns: 'strMessageScreen' }),
      backLinkIcon: <HomeIcon />,
    },
    [MessageTypes.OWN_PROFILE_ERROR]: {
      icon: <BrokenRacket />,
      iconStyle: { width: '100px', height: '100px' },
      header: i18next.t('ownProfileError', { ns: 'strMessageScreen' }),
      infoText: i18next.t('ownProfileErrorInfo', { ns: 'strMessageScreen' }),
      backLinkText: i18next.t('ownProfileErrorLink', { ns: 'strMessageScreen' }),
      backLinkIcon: <RefreshIcon />,
    },
    [MessageTypes.PAGE_RESTRICTED]: {
      icon: <UsersIcon />,
      header: i18next.t('pageRestricted', { ns: 'strMessageScreen' }),
      infoText: i18next.t('pageRestrictedInfo', { ns: 'strMessageScreen' }),
      backLink: getSignInUrl(),
      backLinkText: i18next.t('signInLink', { ns: 'strMessageScreen' }),
      backLinkIcon: null,
    },
    [MessageTypes.SIGNOUT_REQUIRED]: {
      icon: <UsersIcon />,
      header: i18next.t('signOutRequired', { ns: 'strMessageScreen' }),
      infoText: i18next.t('signOutRequiredInfo', { ns: 'strMessageScreen' }),
      backLink: getSignOutUrl(window.location.href),
      backLinkText: i18next.t('signOutLink', { ns: 'strMessageScreen' }),
      backLinkIcon: null,
    },
    [MessageTypes.PAGE_NOT_FOUND]: {
      icon: <FourOFour />,
      iconStyle: { width: '137.5px', height: '84px' },
      header: i18next.t('pageNotFound', { ns: 'strMessageScreen' }),
      infoText: i18next.t('pageNotFoundInfo', { ns: 'strMessageScreen' }),
    },
    [MessageTypes.NETWORK]: {
      icon: <BrokenRacket />,
      iconStyle: { width: '100px', height: '100px' },
      header: i18next.t('somethingWrong', { ns: 'strMessageScreen' }),
      infoText: i18next.t('somethingWrongInfo', { ns: 'strMessageScreen' }),
    },
    [MessageTypes.ALREADY_REGISTERED]: {
      icon: <UsersIcon />,
      header: i18next.t('alreadyRegistered', { ns: 'strMessageScreen' }),
      backLinkText: i18next.t('alreadyRegisteredLink', { ns: 'strMessageScreen' }),
      backLinkIcon: null,
    },
    [MessageTypes.FAST_TRACK_ERROR]: {
      icon: <BrokenRacket />,
      iconStyle: { width: '100px', height: '100px' },
      header: i18next.t('fastTrackError', { ns: 'strMessageScreen' }),
      infoText: i18next.t('fastTrackErrorInfo', { ns: 'strMessageScreen' }),
      backLinkText: i18next.t('fastTrackErrorLink', { ns: 'strMessageScreen' }),
      backLinkIcon: null,
    },
    [MessageTypes.ACTIVATION_ERROR]: {
      icon: <BrokenRacket />,
      iconStyle: { width: '100px', height: '100px' },
      header: i18next.t('activationError', { ns: 'strMessageScreen' }),
      infoText: i18next.t('activationErrorInfo', { ns: 'strMessageScreen' }),
      backLinkText: i18next.t('activationErrorLink', { ns: 'strMessageScreen' }),
      backLinkIcon: null,
    },
    [MessageTypes.ACTIVATION_LOGIN_PROMPT]: {
      icon: <UsersIcon />,
      header: i18next.t('activationLoginPrompt', { ns: 'strMessageScreen' }),
      infoText: i18next.t('activationLoginPromptInfo', { ns: 'strMessageScreen' }),
      backLinkText: i18next.t('signInLink', { ns: 'strMessageScreen' }),
      backLinkIcon: null,
    },
    [MessageTypes.RECAPTCHA_VALIDATION_ERROR]: {
      icon: <Robot />,
      iconStyle: { width: '100px', height: '100px' },
      header: i18next.t('recaptchaValidationError', { ns: 'strMessageScreen' }),
      infoText: (
        <Trans ns='strMessageScreen' i18nKey='recaptchaValidationErrorInfo'>
          reCAPTCHA could not determine with certainty that the form was submitted by a human.
          Please refresh this page and try again. If the issue persists{' '}
          <a href={'/eng/contact'} target='_blank' rel='noopener noreferrer'>
            contact us
          </a>
        </Trans>
      ),
      backLink: `${window.location.href}`,
      backLinkText: i18next.t('recaptchaValidationErrorLink', { ns: 'strMessageScreen' }),
      backLinkIcon: <RefreshIcon />,
      openLinkInNewTab: true,
    },
    [MessageTypes.UNABLE_SUBMIT_PSQ]: {
      icon: <LargeErrorSign />,
      iconStyle: { width: '100px', height: '100px' },
      header: i18next.t('psqUnableSubmit', { ns: 'strMessageScreen' }),
      infoText: i18next.t('psqUnableSubmitInfo', { ns: 'strMessageScreen' }),
      backLinkText: i18next.t('psqUnableSubmitLink', { ns: 'strMessageScreen' }),
      backLinkIcon: <BackIcon />,
    },
    [MessageTypes.PSQ_SUBMIT_ERROR]: {
      icon: <BrokenRacket />,
      iconStyle: { width: '100px', height: '100px' },
      header: i18next.t('psqSubmitError', { ns: 'strMessageScreen' }),
      infoText: i18next.t('psqSubmitErrorInfo', { ns: 'strMessageScreen' }),
      backLinkText: i18next.t('psqSubmitErrorLink', { ns: 'strMessageScreen' }),
      backLinkIcon: <BackIcon />,
    },
    [MessageTypes.REGISTRATION_COMING_SOON]: {
      icon: <ComingSoonIcon />,
      iconStyle: { width: '100px', height: '100px' },
    },
    [MessageTypes.APP_ERROR]: {
      icon: <BrokenRacket />,
      iconStyle: { width: '100px', height: '100px' },
      header: i18next.t('appError', { ns: 'strMessageScreen' }),
      infoText: i18next.t('appErrorInfo', { ns: 'strMessageScreen' }),
      backLink: `${window.location.href}`,
      backLinkText: i18next.t('appErrorLink', { ns: 'strMessageScreen' }),
      backLinkIcon: <RefreshIcon />,
    },
    [MessageTypes.DEFAULT]: {
      icon: <BrokenRacket />,
      iconStyle: { width: '100px', height: '100px' },
      header: i18next.t('somethingWrong', { ns: 'strMessageScreen' }),
      infoText: i18next.t('somethingWrongInfo', { ns: 'strMessageScreen' }),
    },
  } as const)

export const MESSAGE_SCREENS = getMessageScreens()

export type MessageScreen = keyof typeof MESSAGE_SCREENS
